import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import apiRoutes from '../../../app/api/routes';
import { IDENTIFICATIONCODETYPE_RESOURCE } from '../constants';

const TypeService = ComposedComponent =>
  reduxFetch([
    {
      resource: IDENTIFICATIONCODETYPE_RESOURCE,
      method: 'get',
      request: (tag, rejectCallback, t) => ({
        url: apiRoutes.identificationCodeTypes(tag),
        meta: {
          rejectCallback,
          toaster: {
            onErrorMessage: createErrorMessage(t, 'getIdentificationCodeTypeFailed'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default TypeService;
